module.exports = __webpack_public_path__ + "img/image 8.9a4c3c46.png";